import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { TextFormField } from 'lib/form/TextFormField';
import { ButtonV2 } from 'ui/ButtonV2';

interface ReceiptFormProps {
    defaultEmail: string;
    onSubmit: (values: { email: string }) => void | Promise<void>;
    isLoading: boolean;
}

export const ReceiptForm: React.FC<ReceiptFormProps> = ({ defaultEmail, onSubmit, isLoading }) => {
    const { t } = useTranslation();

    const schema = React.useMemo(
        () =>
            Yup.object().shape({
                email: Yup.string()
                    .required(t('FORMS_VALIDATION_REQUIRED'))
                    .email(t('FORMS_VALIDATION_EMAIL'))
            }),
        [t]
    );

    return (
        <Formik
            onSubmit={onSubmit}
            initialValues={{ email: defaultEmail }}
            validationSchema={schema}
            enableReinitialize
        >
            {({ submitForm, isValid }) => (
                <Form>
                    <Box display="flex" alignItems="flex-start" gap={1} width="100%" mx="auto">
                        <Box flex={1}>
                            <TextFormField
                                InputProps={{
                                    endAdornment: (
                                        <ButtonV2
                                            fullWidth={false}
                                            disabled={isLoading || !isValid}
                                            onClick={submitForm}
                                            sx={{ mt: 0, flexShrink: 0, height: '40px' }}
                                            size="small"
                                        >
                                            {t('SUMMARY_RECEIPT_FORM_SUBMIT')}
                                        </ButtonV2>
                                    )
                                }}
                                disabled={isLoading}
                                name="email"
                                type="email"
                                placeholder={t('SUMMARY_RECEIPT_FORM_EMAIL_PLACEHOLDER')}
                            />
                        </Box>
                    </Box>
                </Form>
            )}
        </Formik>
    );
};
